import { render, staticRenderFns } from "./AddressSuggestionField.vue?vue&type=template&id=e3f54d68&scoped=true"
import script from "./AddressSuggestionField.vue?vue&type=script&lang=js"
export * from "./AddressSuggestionField.vue?vue&type=script&lang=js"
import style0 from "./AddressSuggestionField.vue?vue&type=style&index=0&id=e3f54d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f54d68",
  null
  
)

export default component.exports